import { CheckCircle2, History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/intl";

const ACTIONS = {
  publish: "Published",
  rollback: "Restored an earlier version",
  reset_safe: "Reset to the safe built-in theme",
  enable: "Turned a theme on",
  disable: "Turned a theme off",
};

export default function ClinicHistory({ history, presetsById, currentVersion, onRestore, busy }) {
  if (!history.length) return <p className="text-sm text-le-t-2" data-testid="clinic-history-empty">No changes yet.</p>;
  return (
    <ol className="divide-y divide-zinc-100 rounded-lg border border-le-border bg-le-surface" data-testid="clinic-history">
      {history.map((h) => {
        const a = h.after_json || {};
        const isClinic = h.target_type === "clinic";
        const name = presetsById[isClinic ? a.default_preset_id : h.target_id]?.name;
        const current = isClinic && a.version === currentVersion;
        return (
          <li key={h.id} className="flex flex-wrap items-center gap-3 px-3 py-2.5 text-sm" data-testid={`clinic-history-${h.id}`}>
            <History className="h-4 w-4 shrink-0 text-le-t-muted" aria-hidden />
            <div className="min-w-0 flex-1">
              <div className="text-le-text">
                <span className="font-medium">{ACTIONS[h.action] || h.action}</span>
                {name && <> · {name}</>}
                {isClinic && a.version && <span className="text-le-t-2"> · version {a.version}</span>}
              </div>
              <div className="text-xs text-le-t-2">{h.actor_name || "Unknown"} · {fmtDateTime(h.created_at)}</div>
            </div>
            {current && (
              <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-800">
                <CheckCircle2 className="h-3.5 w-3.5" aria-hidden /> Live now
              </span>
            )}
            {isClinic && !current && (
              <Button size="sm" variant="outline" onClick={() => onRestore(h)} disabled={busy} data-testid={`clinic-history-restore-${h.id}`}>
                Restore
              </Button>
            )}
          </li>
        );
      })}
    </ol>
  );
}
